import axios from 'axios';
import { clearSession, getStoredToken } from './auth-storage';

/**
 * Sem env → `/api/v1` + proxy do Vite (dev).
 *
 * Com `VITE_API_URL`:
 * - Só a origem (`http://localhost:3000` ou `https://api.exemplo.com`) → acrescenta `/api/v1`.
 * - Já com sufixo (`.../api/v1`) → usa como está.
 */
function resolveApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_URL?.trim();
  if (!raw) return '/api/v1';
  const base = raw.replace(/\/$/, '');
  if (base.endsWith('/api/v1')) return base;
  return `${base}/api/v1`;
}

const baseURL = resolveApiBaseUrl();

export const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = String(err.config?.url ?? '');
    const isLogin = url.includes('/auth/login');
    // 401 no login = credenciais erradas; não limpar sessão nem redirecionar
    if (err.response?.status === 401 && !isLogin) {
      clearSession();
      if (!window.location.pathname.startsWith('/login')) {
        window.location.assign('/login');
      }
    }
    return Promise.reject(err);
  },
);
